import { Component, Input, TemplateRef, ContentChild, AfterContentInit, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss']
})
export class DataListComponent implements AfterContentInit {
  @Input() data: any[] = [];
  @Input() isLoading = false;
  @Input() emptyMessage = 'No data found.';
  @ContentChild('itemTemplate', { static: false }) itemTemplate?: TemplateRef<any>;
  @ContentChild('loadingTemplate', { static: false }) loadingTemplate?: TemplateRef<any>;
  @ContentChild('emptyTemplate', { static: false }) emptyTemplate?: TemplateRef<any>;
  @Input() columns: number = 1; // Grid columns: 1, 2, 3, or 4
  /** Key to track items by (e.g. 'id') for better *ngFor performance */
  @Input() trackByKey?: string;

  constructor(private cdr: ChangeDetectorRef) {}

  trackByItem(index: number, item: any): number | string {
    if (this.trackByKey && item && item[this.trackByKey] != null) {
      return item[this.trackByKey];
    }
    return index;
  }

  ngAfterContentInit(): void {
    this.cdr.detectChanges();
  }

  get gridClass(): string {
    const cols = {
      1: 'grid-cols-1',
      2: 'grid-cols-1 md:grid-cols-2',
      3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
      4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
    };
    return cols[this.columns as keyof typeof cols] || cols[2];
  }
}
